import { ProductFilter } from '@shopify/hydrogen-react/storefront-api-types';

export const AVAILABLE_ONLY_FILTER: ProductFilter = { available: true };

export function prepareAvailabilityFilter(filters: ProductFilter[]): ProductFilter[] {
  return [...filters, AVAILABLE_ONLY_FILTER];
}
